module.exports = "<span>\n  Měsíční data KN aktuální k {{cadastreDataDate| date: 'd. M. yyyy'}}\n</span>\n"